module.exports = __webpack_public_path__ + "img/vindressurser.5c89313e.jpg";